import React, { Component } from 'react';
import i18next from 'i18next';
import classNames from 'classnames';

import PropTypes from 'prop-types';
import * as CustomPropTypes from 'lib/CustomPropTypes';

import Picture from 'components/Picture';
import Ad from 'components/Ad';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import buildByline from 'lib/buildByline';
import { attribution } from 'lib/social';
import { imageAltForImage } from 'lib/imageAlt';

import styles from './styles.module.scss';

/*
  We might want to change our design to support
  multpile paragraphs in the slide caption.
  for now just joining text.
*/

const markupToString = ({ html }) => `<p>${html}</p>`;
const stringifyCaption = (caption) => {
  if (!Array.isArray(caption)) {
    return '';
  }
  return caption.map(markupToString).join('');
};

class Slide extends Component {
  static propTypes = {
    slide: CustomPropTypes.slide.isRequired,
    slideshowActive: PropTypes.bool,
    isActive: PropTypes.bool,
    social: CustomPropTypes.socialMediaProfiles.isRequired,
  };

  static defaultProps = {
    slideshowActive: false,
    isActive: false,
  };

  getPicture() {
    const { slide } = this.props;

    if (slide.isAdSlot) {
      return (
        <Ad
          slot="galleryslide"
          adClass={classNames(styles.slidePicture, 'slide__picture', 'slide__ad')}
        />
      );
    }

    return (
      <Picture
        className={classNames(styles.slidePicture, 'slide__picture')}
        responsiveFlavors={{
          s: AIMS_FLAVORS.FIT_760w,
          m: AIMS_FLAVORS.FIT_1000w,
          l: AIMS_FLAVORS.FIT_660w,
          xl: AIMS_FLAVORS.FIT_880w,
        }}
        alt={imageAltForImage(slide.image)}
        url={slide.image.url.primary}
        flavor="fit"
      />
    );
  }

  getHeadline() {
    const { slide: { headline } } = this.props;

    if (!headline) {
      return null;
    }

    return (
      <h2 className="slide__title">
        {headline.primary}
      </h2>
    );
  }

  getInfoBody() {
    const {
      slide,
      slideshowActive,
      social,
    } = this.props;

    if (slide.isAdSlot) {
      return (
        <div
          className={
            classNames(styles.slideInfo, 'slide__info', { [styles.slid]: slideshowActive, slide__slid: slideshowActive })
}
        >
          <h2 className="slide__title-ad">
            { i18next.t('Advertisement') }
          </h2>
        </div>
      );
    }

    const shareAttrib = attribution(social);

    return (
      <div
        className={
          classNames(styles.slideInfo, 'slide__info', { [styles.slid]: slideshowActive, slide__slid: slideshowActive })
}
      >
        {this.getHeadline()}
        {/* Have to use dangerouslySetInnerHTML because the API response is an html string
        -- maybe this is something that can be changed API/BE-level */}

        {/* this slide.caption is going to return an array now */}
        <div
          className="slide__caption"

          dangerouslySetInnerHTML={{ __html: stringifyCaption(slide.caption) || slide.image.caption }} // eslint-disable-line
        />

        {this.getCredit()}

        <ul
          className={classNames('slide__social', 'dn-print')}
          data-test="slide"
        >
          <li className="slide__social-text">Share</li>
          <li className="slide__share-facebook">
            <a rel="noopener noreferrer" target="_blank" href={`https://www.facebook.com/sharer/sharer.php?u=${slide.slideshowUrls.primary}`}>
              <span className={classNames('slide__social-icon', 'icon', 'icon-facebook')} />
            </a>
          </li>
          <li className="slide__share-twitter">
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={`https://twitter.com/intent/tweet?text=${slide.slideshowHeadline.social}&via=${shareAttrib}&url=${slide.slideshowUrls.primary}&original_referer=${slide.slideshowUrls.primary}`}
            >
              <span className={classNames('slide__social-icon', 'icon', 'icon-twitter')} />
            </a>
          </li>
        </ul>
      </div>
    );
  }

  getCredit() {
    const { slide } = this.props;

    if (slide.isAdSlot) {
      return null;
    }

    const { source, authors: people } = slide;

    const authors = people.map(({ name }) => name);

    const creditLine = [buildByline(authors), source && source.name].filter((_) => _).join(' / ');

    return (
      <span className="slide__credit">
        &mdash;
        {' '}
        {creditLine}
      </span>
    );
  }

  render() {
    const { isActive, slideshowActive } = this.props;

    return (
      <div
        ref={(container) => { this.container = container; }}
        className={classNames(
          styles.container,
          'slide',
          {
            'slide--active': isActive,
            'slide__slideshow--active': slideshowActive,
          },
        )}
      >
        {this.getPicture()}
        {this.getInfoBody()}
      </div>
    );
  }
}

export default Slide;
